import React, { useState } from 'react';
import Sidebar from '../sidebar/sidebar';
import logo from '../../images/ensenartecorto.png';
import MiPerfil from '../miperfil/miperfil';
import MisCursos from '../miscursos/miscursos';
import './home.css';

function Home({ userEmail, onLogout }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('avisos');

  const avisos = [
    {
      id: 1,
      titulo: 'Bienvenido a tu plataforma',
      contenido: 'Te damos la bienvenida a tu espacio de aprendizaje en EnsenArte.',
      fecha: '2024-05-06',
    },
    {
      id: 2,
      titulo: 'Nuevo curso disponible',
      contenido: 'Se ha añadido un nuevo curso a tu plataforma.',
      fecha: '2024-05-05',
    }
  ];

  const renderContent = () => {
  switch (activeSection) {

    case 'avisos':
      return (
        <div className="home-content-section">
          <h1>📢 Avisos</h1>

          <div className="home-avisos-list">
            {avisos.map((aviso) => (
              <div key={aviso.id} className="home-aviso-card">
                <h3>{aviso.titulo}</h3>
                <p>{aviso.contenido}</p>
                <span>{aviso.fecha}</span>
              </div>
            ))}
          </div>
        </div>
      );

    case 'cursos':
      return <MisCursos />;

    case 'perfil':
      return (
        <MiPerfil
          userEmail={userEmail}
          onLogout={onLogout}
        />
      );

    default:
      return null;
  }
};

  return (
    <div className="home-container">

      <header className="home-header">
        <button 
          className="home-hamburger-btn" 
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          ☰
        </button>

        <img src={logo} alt="EnsenArte" className="home-header-logo" />
      </header>

      <div className="home-main">

        <Sidebar 
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          activeSection={activeSection}
          onSelectSection={setActiveSection}
        />

        <main className="home-content">
          {renderContent()}
        </main>

      </div>
    </div>
  );
}

export default Home;